import React, { Component } from 'react';

import './styles/modalInstallmentsInfo.scss';

export default class ModalInstallmentsInfo extends Component {
  render() {
    return (
      <div className="installments-info">
        <h2>Покупка в рассрочку от Фитрон</h2>
        <div className="installments-info__payments">
          <p className="installments-info__payments__comment">Перейдите к оформлению, чтобы увидеть суммы платежей</p>
        </div>
      </div>
    )
  }
}